const FilledInfoIcon = ({ className }: { className?: string }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      className={className}
    >
      <path
        d="M7.99992 14.6667C4.31802 14.6667 1.33325 11.6819 1.33325 8.00004C1.33325 4.31814 4.31802 1.33337 7.99992 1.33337C11.6818 1.33337 14.6666 4.31814 14.6666 8.00004C14.6666 11.6819 11.6818 14.6667 7.99992 14.6667ZM7.33325 7.33337V11.3334H8.66658V7.33337H7.33325ZM7.33325 4.66671V6.00004H8.66658V4.66671H7.33325Z"
        fill="#609399"
      />
    </svg>
  );
};

export default FilledInfoIcon;
